import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { SettingIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/points-management/points-configuration/customer/$programId')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <CrumbTitle id="pointManagement.pointsConfiguration.referralStage.crumb" icon={SettingIcon} />,
      title: <Translation id="pointManagement.pointsConfiguration.referralStage.title" />,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
